import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { availableLanguagesForUser } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import LanguageRichTextInput from '@/configuration/components/LanguageRichTextInput/LanguageRichTextInput'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import MessageTypeSelector from './MessageTypeSelector/MessageTypeSelector'
import * as Styles from './styles'

const CustomMessage = ({
  enabled,
  message,
  customMessageType,
  customMessageTypeOptions,
  customMessageTypeDisabled,
  onChangeConfig,
  disabled,
  errors = [],
  showToggle = true,
}) => {
  const theme = useTheme()
  const { info } = useContext(AppContext)
  const { t } = useTranslation()
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']
  const languages = availableLanguagesForUser.filter(lang => supportedLanguages.includes(lang))

  const customMessageError = errors.find(e => e.type === errorTypes.actionCustomMessageEmpty)
  const missingLanguages = customMessageError?.missingLanguages || []
  const showInput = !showToggle || enabled
  const showCustomMessageType = showInput && customMessageTypeOptions?.length > 0
  const hasCustomMessageTypeError = errors.some(e => e.type === errorTypes.actionCustomMessageTypeEmpty)

  const handleToggleEnabled = e => {
    onChangeConfig({ custom_message_enabled: e.target.checked })
  }

  const handleChangeMessage = (value, language) => {
    onChangeConfig({ custom_message: { ...message, [language]: value } })
  }

  const handleChangeCustomMessageType = e => {
    onChangeConfig({ custom_message_type: e.target.value })
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Mensaje personalizado')}</Text>
      {showToggle && (
        <Switch
          checked={enabled}
          onChange={handleToggleEnabled}
          label={t('Mostrar un mensaje personalizado cuando esta acción se active')}
          disabled={disabled}
        />
      )}
      {showInput && (
        <LanguageRichTextInput
          languages={languages}
          value={message}
          onChange={handleChangeMessage}
          externalErrorLanguages={missingLanguages}
          inputLabel={t('Mensaje personalizado')}
          helperText={t('Este campo es obligatorio')}
          showInputError
          backgroundColor={theme.colors.background.primary}
          disabled={disabled}
        />
      )}
      {showCustomMessageType && (
        <MessageTypeSelector
          options={customMessageTypeOptions}
          value={customMessageType}
          onChange={handleChangeCustomMessageType}
          disabled={disabled || customMessageTypeDisabled}
          hasError={hasCustomMessageTypeError}
        />
      )}
    </Styles.Container>
  )
}

export default CustomMessage
